import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-real-time-notification',
  templateUrl: './help-add-real-time-notification.component.html',
  styleUrls: ['./help-add-real-time-notification.component.scss']
})
export class HelpAddRealTimeNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
